import React from 'react';
// import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import Modal from 'react-modal';
import { linkPreviewFetch } from '../../../actions/index';
import { Icon } from '../Icon';
import cx from '../../../styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const EmbedLink = (props) => {
    const { t } = props;
    const onLinkInputChange = (e) => {
        const submit = document.querySelector('.submit');
        if (e.target.value.length > 0) {
            submit.classList.add('blue');
        } else {
            submit.classList.remove('blue');
        }
    }
    const onEmbedSubmit = async () => {
        const val = document.querySelector('.link-input').value;
        let linkMatches = [];
        linkMatches = val.match(/([^.\s]+\.[^.\s]{2,}(?:\.[^.\s]{2,})*)/i);
        if (linkMatches && linkMatches.length && props.imagePreviews.length == 0) {
            const url = linkMatches[0].includes('http') ? linkMatches[0] : `https://${linkMatches[0]}`;
            if (url != props.linkPreview.url) {
                props.setLoading(true)
                await props.linkPreviewFetch(url)
                    .then((res) => {
                        if (res === null) {
                            props.addNotificationMessage(t('preview_failed'), 'error')
                        }
                    })
                props.setLoading(false)
                props.toggleEmbedLink()
            }
        } else {
            props.toggleEmbedLink()
            props.addNotificationMessage(t('enter_valid_url'), 'error')
        }
    }
    return (
        <Modal
            isOpen={props.showEmbed}
            onRequestClose={props.toggleEmbedLink}
            overlayClassName={"embed-link-modal"}
        >
            <div className={cx('embed-wrap')}>
                <p className={cx('embed-text')}>{t('embed_URL')}</p>
                <p className={cx('platform-info')}>{t('platforms_supported')}</p>
                <div className={cx('platforms')}>
                    <Icon name="youtube-platform-regular" />
                    <Icon name="instagram-platform-regular" />
                    <Icon name="twitter-platform-regular" />
                    <Icon name="tiktok-platform-regular" />
                </div>
                <input className={cx('link-input')} onChange={(e) => onLinkInputChange(e)} placeholder={t('enter_url')}></input>
                <div className={cx('embed-btn')}>
                    <button className={cx('cancel')} onClick={props.toggleEmbedLink}>{t('cancel')}</button>
                    <button className={cx('submit')} onClick={onEmbedSubmit}>{t('submit')}</button>
                </div>
            </div>
        </Modal>
    );
}

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        linkPreviewFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(EmbedLink));
